import React from "react";
import { Settings, Save, Shield, Globe, Database } from "lucide-react";
import "./Admin.css";

const SettingsManager = () => {
  const settingsSections = [
    {
      icon: <Globe size={20} />,
      title: "General Settings",
      desc: "Site name, timezone, and basic info",
    },
    {
      icon: <Shield size={20} />,
      title: "Security",
      desc: "Admin permissions and password policies",
    },
    {
      icon: <Database size={20} />,
      title: "Data Management",
      desc: "Export conference data and backups",
    },
  ];

  return (
    <div className="admin-page">
      <div className="admin-section-header" style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "1.5rem", fontWeight: "700" }}>
          System Settings
        </h1>
        <p style={{ color: "var(--admin-text-sub)" }}>
          Configure global application parameters and security
        </p>
      </div>

      <div
        className="admin-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(400px, 1fr))",
          gap: "24px",
        }}
      >
        {settingsSections.map((section, idx) => (
          <div key={idx} className="admin-card">
            <div
              className="card-header"
              style={{ display: "flex", alignItems: "center", gap: "12px" }}
            >
              <div style={{ color: "var(--admin-primary)" }}>
                {section.icon}
              </div>
              <h2>{section.title}</h2>
            </div>
            <div style={{ padding: "24px" }}>
              <p
                style={{
                  color: "var(--admin-text-sub)",
                  marginBottom: "20px",
                  fontSize: "0.875rem",
                }}
              >
                {section.desc}
              </p>
              <button
                className="admin-btn"
                style={{
                  width: "100%",
                  border: "1px solid var(--admin-border)",
                  background: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  fontWeight: "600",
                }}
              >
                Configure
              </button>
            </div>
          </div>
        ))}
      </div>

      <div
        className="admin-card"
        style={{ marginTop: "32px", border: "1px solid #fee2e2" }}
      >
        <div
          className="card-header"
          style={{ background: "#fef2f2", color: "#991b1b" }}
        >
          <h2>Danger Zone</h2>
        </div>
        <div style={{ padding: "24px" }}>
          <p
            style={{
              color: "#b91c1c",
              fontSize: "0.875rem",
              marginBottom: "16px",
            }}
          >
            Sensitive actions that can significantly impact the conference data.
          </p>
          <button
            className="admin-btn"
            style={{ background: "#ef4444", color: "white", border: "none" }}
          >
            Reset App Data
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsManager;
